const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      width="100%"
      viewBox="0 0 24.312 24.312"
      className="stroke-current"
    >
      <g
        id="X_TOP_BUTTON"
        data-name="X TOP BUTTON"
        transform="translate(1.061 1.061)"
      >
        <line
          id="Line_178"
          data-name="Line 178"
          x2="31.382"
          transform="translate(0 0) rotate(45)"
          fill="none"
          strokeWidth={3}
        />
        <line
          id="Line_180"
          data-name="Line 180"
          x2="31.381"
          transform="translate(22.19 0) rotate(135)"
          fill="none"
          strokeWidth={3}
        />
      </g>
    </svg>
  )
}

export default CloseIcon
